import Service from 'react-reservice';

import { ICountryStoneinnoDetail } from '@aqx-core/common/api/account';
import { ISignUpCrmBasicParams } from '@aqx-core/common/api/auth';

import { ESignUpCrmContent } from './types';

export interface ISignUpCrmServiceContext {
  loading: boolean;
  content: ESignUpCrmContent;
  countries: ICountryStoneinnoDetail[];
  basicInfo: ISignUpCrmBasicParams | undefined;
  redirectUrl: string;
  otpTimeoutInSec: number | undefined;
  otpExpiryTime: number | undefined;
}

const defaultContext: ISignUpCrmServiceContext = {
  loading: false,
  content: ESignUpCrmContent.BASIC,
  countries: [],
  basicInfo: undefined,
  redirectUrl: '',
  otpTimeoutInSec: undefined,
  otpExpiryTime: undefined
};

class SignUpCrmService extends Service<ISignUpCrmServiceContext> {
  constructor() {
    super();

    this.context = { ...defaultContext };
  }

  setContent = (content: ESignUpCrmContent) => {
    this.context.content = content;
  };

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setBasicInfo = (basicInfo: ISignUpCrmBasicParams) => {
    this.context.basicInfo = basicInfo;
  };

  setCountries = (countries: ICountryStoneinnoDetail[]) => {
    this.context.countries = countries;
  };

  setRedirectUrl = (url: string) => {
    this.context.redirectUrl = url;
  };

  setOtpTimeoutInSec = (timeoutInSec: number | undefined) => {
    this.context.otpTimeoutInSec = timeoutInSec;
  };

  setOtpExpiryTime = (expiryTime: number | undefined) => {
    this.context.otpExpiryTime = expiryTime;
  };

  reset = () => {
    this.context = {
      ...defaultContext
    };
  };
}

export const signUpCrmService = new SignUpCrmService();
